var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// QUEUE_SYSTEM_STATUS
var QUEUE_SYSTEM_STATUS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query QueueSystemLiveStatus {\n    queue_system_live_status\n  }\n"], ["\n  query QueueSystemLiveStatus {\n    queue_system_live_status\n  }\n"])));
export var useQueueSystemLiveStatusQuery = function (options) {
    return useQuery(QUEUE_SYSTEM_STATUS, options);
};
export default QUEUE_SYSTEM_STATUS;
var templateObject_1;
